export default {
  header: {
    home: "首页",
    about: "About Zhizhen",
    product: "Solution",
    esg: "esg",
    news: "Group News",
    join: "Recruitment",
    contact: "Contact Us",
  },
  footer: {
    sitemap: "Site Maps",
    hotservice: "Service Hotline",
    about: "About Zhizhen",
    about1: "Company Culture",
    about2: "Company History",
    about3: "Company Layout",
    about4: "Research Institute",
    product: "Solution",
    esg: "esg",
    news: "Group News",
    join: "Recruitment",
    contact: "Contact Us",
    tel:"Phone",
    mail:"E-Mail",
    address:"Address"
  },
  about: {
    layout: "Company Layout",
    introduction: "Zhizhen Research Institute",
  },
  product: {
    title: "Representative Products",
    nav: "Home",
    area: "Application Areas",
  },
  news: {
    title: "Group News",
    source: "Source",
    date: "Date",
    category1: "Yunjing News",
    category2: "Industry News",
    view: "MORE",
    detail:'Detail',
    tip:'No data yet'
  },
  join:{
    title:'Recruitment',
    city:'City',
    post:'Post',
    tip:'No data yet',
    description:'Job Description',
    detail:'Job Detail',
    back:'Back'
  },
  contact: {
    title: "Contact Us",
    phone: "Phone",
    email: "Email",
    fax:'Fax',
    address: "Address",
    navigation: "Map navigation",
  },
};
